const SCROLL_ANIMATION_TRIGGER_CLASSNAME = 'scroll-trigger';
const SCROLL_ANIMATION_OFFSCREEN_CLASSNAME = 'scroll-trigger--offscreen';
const SCROLL_ZOOM_IN_TRIGGER_CLASSNAME = 'animate--zoom-in';
const SCROLL_ANIMATION_CANCEL_CLASSNAME = 'scroll-trigger--cancel';

// Scroll in animation logic
function onIntersection(elements, observer) {
  elements.forEach((element, index) => {
    if (element.isIntersecting) {
      const elementTarget = element.target;
      if (elementTarget.classList.contains(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME)) {
        elementTarget.classList.remove(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
        if (elementTarget.hasAttribute('data-cascade'))
          elementTarget.setAttribute('style', `--animation-order: ${index};`);
      }
      observer.unobserve(elementTarget);
    } else {
      element.target.classList.add(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
      element.target.classList.remove(SCROLL_ANIMATION_CANCEL_CLASSNAME);
    }
  });
}

function initializeScrollAnimationTrigger(rootEl = document, isDesignModeEvent = false) {
  const animationTriggerElements = Array.from(rootEl.getElementsByClassName(SCROLL_ANIMATION_TRIGGER_CLASSNAME));
  if (animationTriggerElements.length === 0) return;

  if (isDesignModeEvent) {
    animationTriggerElements.forEach((element) => {
      element.classList.add('scroll-trigger--design-mode');
    });
    return;
  }

  const observer = new IntersectionObserver(onIntersection, {
    rootMargin: '0px 0px -50px 0px',
  });
  animationTriggerElements.forEach((element) => observer.observe(element));
}

// Zoom in animation logic
function initializeScrollZoomAnimationTrigger() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const animationTriggerElements = Array.from(document.getElementsByClassName(SCROLL_ZOOM_IN_TRIGGER_CLASSNAME));
  if (animationTriggerElements.length === 0) return;

  const scaleAmount = 0.2 / 100;
  const elementsData = [];

  // Cache layout measurements to avoid layout thrashing on scroll
  const measureElements = () => {
    animationTriggerElements.forEach((element, index) => {
      const rect = element.getBoundingClientRect();
      elementsData[index] = {
        element: element,
        top: rect.top + window.scrollY,
        height: element.offsetHeight,
        visible: elementsData[index] ? elementsData[index].visible : false
      };
    });
  };

  measureElements();

  // Single IntersectionObserver for all zoom elements
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      const idx = animationTriggerElements.indexOf(entry.target);
      if (idx !== -1 && elementsData[idx]) {
        elementsData[idx].visible = entry.isIntersecting;
      }
    });
  }, { rootMargin: '100px 0px 100px 0px' });

  animationTriggerElements.forEach((element) => observer.observe(element));

  // Single throttled scroll handler using cached parameters (zero DOM reads)
  let ticking = false;
  const onScroll = () => {
    if (!ticking) {
      requestAnimationFrame(() => {
        const scrollY = window.scrollY;
        const viewportHeight = window.innerHeight;

        elementsData.forEach((data) => {
          if (!data.visible) return;

          let percentage = 0;
          if (data.top > scrollY + viewportHeight) {
            percentage = 0;
          } else if (data.top + data.height < scrollY) {
            percentage = 100;
          } else {
            const distance = scrollY + viewportHeight - data.top;
            percentage = Math.round(distance / ((viewportHeight + data.height) / 100));
          }

          data.element.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * percentage);
        });
        ticking = false;
      });
      ticking = true;
    }
  };

  window.addEventListener('scroll', onScroll, { passive: true });
  
  window.addEventListener('resize', () => {
    measureElements();
    onScroll();
  }, { passive: true });
  
  window.addEventListener('load', () => {
    measureElements();
    onScroll();
  });
}

window.addEventListener('DOMContentLoaded', () => {
  initializeScrollAnimationTrigger();
  initializeScrollZoomAnimationTrigger();
});

if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => initializeScrollAnimationTrigger(event.target, true));
  document.addEventListener('shopify:section:reorder', () => initializeScrollAnimationTrigger(document, true));
}
